import { useHistory, useLocation } from 'react-router-dom';
import Accordion from './organisms/Accordion';
import * as S from './style';
import BuilderComponent from '../ServiceSupport/molecules/BuilderComponent/BuilderComponent';
import queryString from 'query-string';
import BuilderModelComponent from 'srs.sharedcomponents/lib/esm/components/builder/srs.builderModel.components';
import { getWebsiteName } from 'srs.sharedcomponents/lib/esm/utils/websiteName';
import { IBuilderModelParameter } from 'srs.sharedcomponents/lib/esm/models/builder/builderModelParameter.model';
import { LinksBuilderContent } from './builderStyles';
import { useTranslate } from 'srs.sharedcomponents/lib/esm/hooks/useTranslate';
import ContactUs from 'srs.sharedcomponents/lib/esm/components/organisms/FeedbackForm/FeedbackForm';
import FeedBackButton from './atoms/FeedBackButton/FeedBackButton';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'srs.sharedcomponents/lib/esm/redux/hooks';
import { getContact } from 'srs.sharedcomponents/lib/esm/redux/slices/contactUsSlice';
import { Helmet } from 'react-helmet-async';

const ServiceSupport = () => {
    const navigation = useHistory();
    const { search } = useLocation();
    const { expanded } = queryString.parse(search);
    const { translate } = useTranslate();
    const [showFeedbackForm, setShowFeedbackForm] = useState(false);
    const dispatch = useAppDispatch();
    const [isFaqLoaded, setIsFaqLoaded] = useState(false);

    useEffect(() => {
        setIsFaqLoaded(false);
        if (expanded === 'faq') {
            setIsFaqLoaded(true);
        }
    }, [search]);

    const schemaMarkUpData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntry: [
            {
                '@type': 'Question',
                name: 'How do I contact support?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'You can contact support via the contact form on this page',
                },
            },
        ],
    };
    const handleChange = (panel: string) => {
        const isPanelExpanded = expanded === panel;

        if (isPanelExpanded) {
            navigation.push(`?expanded=`);
        } else {
            navigation.push(`?expanded=${panel}`);
        }
    };
    const getHomeParameters = () => {
        const websiteName = getWebsiteName()?.websiteName;
        if (websiteName) {
            const homeParameters: IBuilderModelParameter = {
                websiteName: websiteName,
            };
            return homeParameters;
        } else return {};
    };
    useEffect(() => {
        dispatch(getContact());
    }, []);
    return (
        <S.Wrapper>
            {isFaqLoaded && (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(schemaMarkUpData)}
                    </script>
                </Helmet>
            )}
            <div className="container d-flex justify-content-center">
                <div className="col-10">
                    <S.Title>{translate('serviceSupport.menu3.title')}</S.Title>
                    <h2 style={{ display: 'none' }}>
                        {translate('serviceSupport.menu3.item1')}
                    </h2>
                    <Accordion
                        title={translate('serviceSupport.menu3.item1')}
                        expanded={expanded === 'contact-us'}
                        onChange={() => handleChange('contact-us')}
                    >
                        <BuilderComponent
                            modelKey="service-and-support-contact-us"
                            path="/service-support"
                            modelName="service-and-support-contact-us"
                        />
                    </Accordion>
                    <h2 style={{ display: 'none' }}>
                        {translate('serviceSupport.menu3.item2')}
                    </h2>
                    <Accordion
                        title={translate('serviceSupport.menu3.item2')}
                        expanded={
                            expanded === 'find-my-service-optimization-manager'
                        }
                        onChange={() =>
                            handleChange('find-my-service-optimization-manager')
                        }
                    >
                        <BuilderComponent
                            modelKey="sales-rep-accordion"
                            path="/service-support"
                            modelName="sales-rep-accordion"
                        />
                    </Accordion>
                    <h2 style={{ display: 'none' }}>
                        {translate('serviceSupport.menu3.item4')}
                    </h2>
                    <Accordion
                        noPadding
                        title={translate('serviceSupport.menu3.item4')}
                        expanded={expanded === 'faq'}
                        onChange={() => handleChange('faq')}
                    >
                        {showFeedbackForm ? (
                            <>
                                <S.BackButton
                                    onClick={() => setShowFeedbackForm(false)}
                                >
                                    {'<'}
                                    {translate('serviceSupport.menu3.item4')}
                                </S.BackButton>
                                <div style={{ padding: '0 12px 12px 12px' }}>
                                    <ContactUs />
                                </div>
                            </>
                        ) : (
                            <>
                                <BuilderComponent
                                    modelKey="faq"
                                    path="/faq"
                                    modelName="faq-rotunda"
                                />
                                <FeedBackButton
                                    onClick={() =>
                                        (window.location.href = '/feedback')
                                    }
                                >
                                    {translate('serviceSupport.askQuestion')}
                                </FeedBackButton>
                            </>
                        )}
                    </Accordion>
                    <h2 style={{ display: 'none' }}>
                        {translate('serviceSupport.menu3.item5')}
                    </h2>
                    <Accordion
                        title={translate('serviceSupport.menu3.item5')}
                        expanded={expanded === 'policies'}
                        onChange={() => handleChange('policies')}
                    >
                        <LinksBuilderContent>
                            <BuilderModelComponent
                                modelKey="policesLinks"
                                path="/policesLinks"
                                modelName="header-menu-option"
                                modelParameters={getHomeParameters()}
                            ></BuilderModelComponent>
                        </LinksBuilderContent>
                    </Accordion>
                </div>
            </div>
        </S.Wrapper>
    );
};

export default ServiceSupport;
